import { render, staticRenderFns } from "./ResidentHistory.vue?vue&type=template&id=b9345f0c&scoped=true&"
import script from "./ResidentHistory.vue?vue&type=script&lang=ts&"
export * from "./ResidentHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentHistory.vue?vue&type=style&index=0&id=b9345f0c&lang=scss&scoped=true&"
import style1 from "./ResidentHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9345f0c",
  null
  
)

export default component.exports